import { useApiData } from "@/hooks/useApiData";
import { Link } from "wouter";
import { Plus, Edit, Trash2, Star } from "lucide-react";
import api from "@/lib/api";
import type { Testimonial } from "@shared/types";

export default function TestimonialList() {
  const { data: testimonials, refetch } = useApiData<Testimonial[]>("/testimonials");

  const handleDelete = async (id: number) => {
    if (!confirm("Delete this testimonial?")) return;
    await api.delete(`/testimonials/${id}`);
    refetch();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white font-[Rubik]">Testimonials</h1>
        <Link
          href="/admin/testimonials/new"
          className="inline-flex items-center gap-2 bg-[#66CDAA] hover:bg-[#57b899] text-[#0F172A] font-bold px-4 py-2 rounded-xl text-sm transition-colors"
        >
          <Plus className="w-4 h-4" /> New Testimonial
        </Link>
      </div>

      <div className="space-y-2">
        {testimonials?.map((t) => (
          <div
            key={t.id}
            className="flex items-center gap-4 p-4 rounded-xl bg-white/[0.02] border border-white/5 hover:border-white/10 transition-colors"
          >
            <div className="flex-1 min-w-0">
              <span className="text-white font-medium">{t.name}</span>
              <div className="text-xs text-white/30 mt-0.5">
                {t.company} &middot;{" "}
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-3 h-3 inline fill-[#66CDAA] text-[#66CDAA]" />
                ))}
              </div>
            </div>
            <div className="flex gap-1 shrink-0">
              <Link
                href={`/admin/testimonials/${t.id}`}
                className="p-2 text-white/30 hover:text-[#66CDAA] transition-colors"
              >
                <Edit className="w-4 h-4" />
              </Link>
              <button
                onClick={() => handleDelete(t.id)}
                className="p-2 text-white/30 hover:text-red-400 transition-colors"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}

        {testimonials?.length === 0 && (
          <div className="text-center py-12 text-white/30">No testimonials yet.</div>
        )}
      </div>
    </div>
  );
}
